import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, type Changelog } from '../lib/api';
import { parseDay } from '../lib/calendar';
import { dNum } from '../lib/domain';
import { ErrorBox, Loading, PageHead } from '../ui';
import { useBarTitle } from '../barTitle';

const KIND = { neu: 'Neu', verbessert: 'Verbessert', behoben: 'Behoben' } as const;

export default function WasIstNeu() {
  useBarTitle('Was ist neu'); // also while loading
  const qc = useQueryClient();
  const { data, error, isLoading } = useQuery({ queryKey: ['changelog'], queryFn: () => api<Changelog>('/changelog') });
  // opening this page counts as "seen": the dot at the profile picture disappears
  const unseen = data?.unseen;
  useEffect(() => {
    if (unseen)
      void api('/changelog/seen', { method: 'PUT' }).then(() => qc.invalidateQueries({ queryKey: ['changelog'] }));
  }, [unseen, qc]);
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorBox error={error} />;
  return (
    <>
      <PageHead title="Was ist neu" />
      <div className="releases">
        {data.releases.map(r => (
          <section key={r.version} className="panel release" id={`v${r.version}`}>
            <p className="eyebrow">
              Version {r.version} · {dNum(parseDay(r.date) ?? new Date(r.date))}
            </p>
            {r.title && <h2 className="d-title">{r.title}</h2>}
            <ul>
              {r.changes.map((c, i) => (
                <li key={i}>
                  <span className={`chg chg-${c.kind}`}>{KIND[c.kind]}</span> {c.text}
                  {c.help && (
                    <>
                      {' '}
                      <Link to={`/hilfe#${c.help}`}>Mehr dazu</Link>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </>
  );
}
